import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { StorePickerDialogComponent } from './store-picker-dialog.component';

@NgModule({
  declarations: [StorePickerDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    DialogModule,
    TagModule,
    ButtonModule,
    ProgressSpinnerModule,
  ],
  exports: [StorePickerDialogComponent],
})
export class StorePickerDialogModule {}
